<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <div>
            <el-card class="box-card2">
                <div slot="header" class="clearfix">
                    <span class="ptitle">门店授权列表</span>
                    <el-button
                        class="pull-right"
                        icon="fa fa-home"
                        size="mini"
                        @click="storeSetting"
                        >门店设置</el-button
                    >
                    <el-button
                        icon="el-icon-back"
                        type="primary"
                        class="pull-right right-10"
                        @click="backTo"
                        size="mini"
                        >返回</el-button
                    >
                    <!-- <el-button
                        class="pull-right "
                        icon="fa fa-home"
                        size="mini"
                        @click="storeSetting1"
                        >更新门店日期</el-button
                    > -->

                    <div class="pull-right right-10">
                        <el-input
                            placeholder="请输入门店编码或名称"
                            prefix-icon="el-icon-search"
                            v-model="queryParam.storeName"
                            size="mini"
                        ></el-input>
                    </div>
                    <el-select
                        v-model="queryParam.status"
                        class="pull-right right-10"
                        placeholder="请选择状态"
                        size="mini"
                        filterable
                        clearable
                    >
                        <el-option
                            v-for="item in statusList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    <span class="pull-right left-10">状态:</span>
                </div>
                <el-col :lg="18" :md="20" :sm="20" :xs="24" v-show="!visible">
                    <p><i class="el-icon-menu right-20"></i>起止日期设置</p>

                    <el-form
                        :label-position="labelPosition"
                        label-width="130px"
                        class="idadmin"
                        :model="setModel"
                        :rules="rules"
                        ref="refForm"
                    >
                        <el-form-item label="当前选择门店" :required="true">
                            <el-select
                                v-model="selStoreIds"
                                placeholder="选择门店"
                                size="mini"
                                class="width100"
                                @change="storeChange"
                                filterable
                                multiple
                                @remove-tag="removeTag"
                            >
                                <el-option
                                    label="全选"
                                    value="全选"
                                ></el-option>
                                <el-option
                                    v-for="item in storesList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="启用时间" prop="startTime">
                            <el-date-picker
                                v-model="setModel.startTime"
                                style="width: 100%"
                                placeholder="选择日期"
                                @change="changeEnd"
                                :picker-options="pickerOptionsStart"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime">
                            <el-date-picker
                                v-model="setModel.endTime"
                                style="width: 100%"
                                placeholder="选择日期"
                                @change="changeStart"
                                :picker-options="pickerOptionsEnd"
                            ></el-date-picker>
                        </el-form-item>

                        <el-button
                            type="info"
                            size="medium"
                            @click="setClose"
                            icon="el-icon-close"
                            >关闭</el-button
                        >
                        <el-button
                            type="primary"
                            size="medium"
                            @click="setSubmit"
                            icon="el-icon-check"
                            >保存</el-button
                        >
                    </el-form>
                </el-col>
                <el-col :span="24" v-show="visible">
                    <!--门店列表-->
                    <el-table
                        :data="storeTableData"
                        border
                        size="mini"
                        ref="storeTableData"
                        :row-key="getRowKeys"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button
                                    type="primary"
                                    icon="el-icon-edit"
                                    circle
                                    @click="
                                        editStoreRow(scope.$index, scope.row)
                                    "
                                    size="mini"
                                ></el-button>

                                <el-button
                                    v-if="
                                        remainDays(
                                            scope.row.startTime,
                                            scope.row.endTime
                                        ) < 0
                                    "
                                    type="danger"
                                    icon="el-icon-delete"
                                    circle
                                    @click="
                                        deleteCurrentStore(
                                            scope.$index,
                                            scope.row
                                        )
                                    "
                                    size="mini"
                                ></el-button>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="name"
                            label="门店名称"
                            width="170"
                        ></el-table-column>
                        <el-table-column
                            prop="storeCode"
                            label="门店编号"
                        ></el-table-column>
                        <el-table-column
                            prop="brandName"
                            label="品牌名称"
                        ></el-table-column>
                        <el-table-column label="到期时间">
                            <template slot-scope="scope">{{
                                timeFormat(scope.row.endTime)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="距离天数">
                            <template slot-scope="scope">
                                <div :style="daysColor(scope.row)">
                                    {{
                                        remainDays(
                                            scope.row.startTime,
                                            scope.row.endTime
                                        )
                                    }}
                                </div></template
                            >
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <i
                                    :class="statusColor(scope.row)"
                                    style="margin-right: 10px"
                                ></i>
                                {{ statusFormat(scope.row) }}
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="storeDataApiUrl"
                        :GetData="getStoreData"
                        :queryParam="queryParam"
                        :isInit="false"
                    ></pagerBar>
                </el-col>
            </el-card>
        </div>
    </div>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
import moment from 'moment'

export default {
    components: {
        treeselect,
        pagerBar
    },
    data() {
        return {
            isCanDelete: false,
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            pickerOptionsStart: {},
            pickerOptionsEnd: {},
            openloading: false,
            storeDataApiUrl:
                config.BASE_Middle_API + 'StoreAuthorize/GetListByPage',
            storeApiUrl: config.BASE_Middle_API + 'StoreAuthorize',
            visible: true,
            selOrder: [],
            selOrderIds: [],
            statusList: [
                { id: 2, name: '即将过期' },
                { id: 3, name: '过期失效' },
                { id: 4, name: '有效' }
            ],
            selStoreIds: [], //选中的门店ID集合
            moduleConfID: this.$route.query.moduleConfID, //模块ID
            tenantID: this.$route.query.tenantID,
            queryParam: {
                BrandID: '',
                storeName: '',
                ConfigID: '',
                stauts: ''
            },
            storeTableData: [], //门店列表数据
            labelPosition: 'left',
            storesList: [],
            setModel: {
                startTime: '', //开始时间
                endTime: '' //结束时间
            },
            rules: {
                startTime: [
                    {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }
                ],
                endTime: [
                    {
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'change'
                    }
                ]
            }
        }
    },
    mounted: function () {
        this.getRouteParam()
        this.changeStart()
        this.changeEnd()
    },
    methods: {
        deleteCurrentStore(index, row) {
            const _this = this
            this.$confirm(
                '确定要清除当前已过期门店【' +
                    row.name +
                    '】的配置信息吗?清除后不可恢复，请谨慎操作',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                .then(() => {
                    _this.openloading = true
                    AjaxHelper.post(
                        _this.storeApiUrl + '/ChangeStoreInfo?id=' + row.id
                    ).then(function (r) {
                        if (r.success) {
                            _this.$message({
                                type: 'success',
                                message: '清除成功!'
                            })
                            _this.openloading = false

                            _this.$refs.storeTableData.clearSelection()
                            _this.$refs.refPagerBar.Refresh()
                        }
                    })
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                    _this.openloading = false
                })
        },
        editStoreRow(index, row) {
            //编辑门店
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetStoreList', {
                configID: _this.moduleConfID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.storesList = response.result.storeList
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })

            _this.visible = false
            _this.setModel.startTime = moment(row.startTime)
            _this.setModel.endTime = moment(row.endTime)
            _this.selStoreIds.push(row.id)
            _this.changeStart()
            _this.changeEnd()
        },

        getRowKeys(row) {
            return row.id
        },
        handleSelectionChange(val) {
            const _this = this
            if (_this.selOrder.length == 0) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            } else {
                let b = false
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        b = true
                        item.value = val
                    }
                })
                if (!b) {
                    _this.selOrder.push({
                        key: _this.$refs.refPagerBar.currentPage,
                        value: val
                    })
                }
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.storeTableData.find(
                            (tableRow) => tableRow.id === row.id
                        )
                        this.$refs.storeTableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.storeTableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.id === row.id)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (!_this.selOrder.find((item) => item.id === key.id)) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item.id !== row.id
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.storeTableData)
            } else {
                this.removeRows(this.storeTableData)
            }
        },

        storeSetting1() {
            const _this = this
            _this.openloading = true
            AjaxHelper.post(_this.storeApiUrl + '/ChangeStoreTime')
                .then(function (response) {
                    if (response.success) {
                        _this.openloading = false
                        _this.Refresh()
                    }
                })
                .catch(function (error) {
                    _this.openloading = false
                })
        },
        changeStart() {
            this.pickerOptionsStart = Object.assign(
                {},
                this.pickerOptionsStart,
                {
                    disabledDate: (time) => {
                        return time.getTime() > this.setModel.endTime
                    }
                }
            )
        },
        changeEnd() {
            this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
                disabledDate: (time) => {
                    return time.getTime() < this.setModel.startTime
                }
            })
        },

        removeTag(val) {
            if (val === '全选') {
                this.selStoreIds = []
            }
        },
        storeChange(val) {
            var end = val[val.length - 1]
            if (
                !val.includes('全选') &&
                val.length === this.storesList.length
            ) {
                val.unshift('全选')
            } else if (val.includes('全选') && val.length == 1) {
                this.storesList.map((item) => {
                    val.push(item.id)
                })
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length &&
                end == '全选'
            ) {
                val = []
                this.storesList.map((item) => {
                    val.push(item.id)
                })
                val.unshift('全选')
                // this.value = val;
            } else if (
                val.includes('全选') &&
                val.length - 1 < this.storesList.length
            ) {
                val = val.filter((item) => {
                    return item !== '全选'
                })
                // this.value = val;
            }
            // 注意，加上  this.value = val，确保勾选值同步
            this.selStoreIds = val
        },

        storeSetting() {
            //门店设置
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetStoreList', {
                configID: _this.moduleConfID,
                status: _this.queryParam.status
            })
                .then(function (response) {
                    if (response.success) {
                        _this.storesList = response.result.storeList
                        _this.setModel.startTime = response.result.startTime
                        _this.setModel.endTime = response.result.endTime

                        _this.visible = false
                        _this.selStoreIds = []
                        // _this.selOrderIds = [];
                        // _this.selOrder.forEach((item) => {
                        //     if (item.value != null && item.value.length > 0) {
                        //         item.value.forEach((v) => {
                        //             _this.selOrderIds.push(v.id);
                        //         });
                        //     }
                        // });
                        // _this.selStoreIds = _this.selOrderIds;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        backTo() {
            this.$router.push({
                path: '/initialization/storeAuthorize',
                query: {
                    tenantID: this.tenantID
                }
            })
        },
        getRouteParam() {
            const _this = this
            //判断是否存在参数信息
            if (!$.isEmptyObject(_this.$route.query)) {
                //判断是新建修改还是查看
                _this.moduleConfID = _this.$route.query.moduleConfID
                _this.queryParam.ConfigID = _this.moduleConfID
            } else {
                _this.$router.push({
                    path: '/initialization/storeAuthorize'
                })
            }
        },
        getStoreData(d) {
            const _this = this
            _this.openloading = true
            _this.storeTableData = d
            _this.openloading = false
        },
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        daysColor(item) {
            const days =
                moment(item.endTime).diff(
                    new moment().format('YYYY-MM-DD'),
                    'days'
                ) + 1
            if (days <= 0) {
                return 'color:red'
            }
        },
        remainDays(start, end) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(start).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                const daysone =
                    moment(end).diff(
                        moment(start).format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                return daysone
            } else {
                const days =
                    moment(end).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days <= 0) {
                    return days
                }
                return days
            }
        },
        statusFormat(item) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return '未启用'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1 //结束时间算一天 需+1
                if (days < 30 && days > 0) {
                    return '即将到期'
                } else if (days <= 0) {
                    return '过期失效'
                } else {
                    return '有效'
                }
            }
        },
        statusColor(item) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return 'fa fa-circle el-info'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days < 30 && days > 0) {
                    return 'fa fa-circle el-warning'
                } else if (days <= 0) {
                    return 'fa fa-circle el-danger'
                } else {
                    return 'fa fa-circle el-success'
                }
            }
        },
        setClose() {
            //关闭配置页面
            this.visible = true
            if (this.$refs['refForm']) {
                this.$refs['refForm'].resetFields()
            }
            this.selStoreIds = []
        },
        setSubmit() {
            //配置提交
            const _this = this
            _this.$refs['refForm'].validate((valid) => {
                if (valid) {
                    if (_this.selStoreIds.length == 0) {
                        _this.$notify({
                            title: '提示',
                            message: '请选择要设置的门店',
                            type: 'error',
                            position: 'bottom-right',
                            duration: 0
                        })
                        return
                    }
                    _this.openloading = true
                    let confirmData = {}
                    confirmData = Object.assign({}, _this.setModel)
                    confirmData.startTime = moment(
                        _this.setModel.startTime
                    ).format('YYYY-MM-DD')
                    confirmData.endTime = moment(_this.setModel.endTime).format(
                        'YYYY-MM-DD'
                    )
                    // confirmData.storeIds = _this.selStoreIds;
                    let shopIds = []
                    _this.selStoreIds.forEach((t) => {
                        if (t != '全选') {
                            shopIds.push(t)
                        }
                    })
                    confirmData.storeIds = shopIds
                    AjaxHelper.post(
                        _this.storeApiUrl + '/EditBatchTime',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '提示',
                                    message: '批量配置成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.setModel = {}
                                _this.selStoreIds = []

                                _this.visible = true
                                _this.openloading = false
                                _this.$refs['refForm'].resetFields()
                                _this.setModel = {
                                    startTime: moment(), //开始时间
                                    endTime: moment() //结束时间
                                }
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            })
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        }
    }
}
</script>

<style scoped="scoped">
.left300 {
    float: left;
    width: 220px;
}

.contentMode {
    float: left;
    width: -webkit-calc(100% - 240px);
    width: calc(100% - 240px);
}
.idadmin .el-form-item__content {
    line-height: none !important;
}

.noticeDialog h3 span {
    font-size: 13px;
}

.notify_p {
    text-indent: 2em;
    line-height: 2;
    padding: 5px 0;
}
</style>
<style>
.idadmin .el-form-item__content {
    line-height: 20px !important;
}
</style>
